export default __webpack_public_path__ + "static/media/Icon9_On.3bab12db.png";